require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./eventi-guida-storico-critica-allarchitettura-del-xx-secolo-nel-cantone-ticino-vol-i.json") })
        }
      }, "path---eventi-guida-storico-critica-allarchitettura-del-xx-secolo-nel-cantone-ticino-vol-i");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---eventi-guida-storico-critica-allarchitettura-del-xx-secolo-nel-cantone-ticino-vol-i!./.cache/json/eventi-guida-storico-critica-allarchitettura-del-xx-secolo-nel-cantone-ticino-vol-i.json
// module id = 654
// module chunks = 231608221292675